import React, { FC } from "react";
import { Box } from "@mui/material"
import { CategoryInfo } from "../../filtered/types"
import { categoryTab } from "../categoryTabsStyles"
import style from "../styles.module.css"
import { useAppSelector } from "../../../app/hooks";
import { selectCurrentTypeIds } from "../../../shared/filter/selectors";

export type CategoryItemProps = {
  category: CategoryInfo
  click: (value: number) => void
}

const CategoryItem: FC<CategoryItemProps> = (props) => {
  const { category: cat } = props
  const currentIds = useAppSelector(selectCurrentTypeIds)
  const clickHandler = () => {
    props.click(cat.id)
  }

  const hasSelection = currentIds !== undefined && currentIds.length > 0
  const isSelected = hasSelection && currentIds.includes(cat.id)

  // Серой бывает только невыбранная плитка, когда выбрана другая.
  // Если ничего не выбрано — это режим «Все», все плитки обычные.
  const dimmed = hasSelection && !isSelected

  return (
    <Box
      onClick={clickHandler}
      sx={{
        ...categoryTab,
        opacity: dimmed ? 0.45 : 1,
        transition: "opacity 0.2s ease, filter 0.2s ease",
      }}
    >
      <picture>
        <img
          className={style.category_card}
          src={cat.url}
          srcSet={cat.srcset}
          alt={cat.title}
          style={{
            filter: dimmed ? "grayscale(100%)" : "none",
            transition: "filter 0.2s ease",
          }}
        />
      </picture>
    </Box>
  )
}
export default CategoryItem
